export const truncate = (source: string, maxLength: number) => {
    const maxSource = source.substring(0, maxLength);
    if (source.length < maxLength) return source;
    const indexOflastSpace = maxSource.lastIndexOf('</')
    if (indexOflastSpace === -1) return maxSource;
    return `${source.substring(0, indexOflastSpace)} ...` 
}